import { db } from "@/firebase";
import {
  getDocs,
  collection,
  addDoc,
  updateDoc,
  doc,
  deleteDoc,
  where,
  query,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";

const knowledge = {
  state: {
    items: [],
    sources: [],
  },
  mutations: {
    setItems(state, val) {
      state.items = val;
    },
    removeKnowledgeItem(state, val) {
      state.items = state.items.filter((item) => item.uid !== val);
    },
    addKnowledgeItem(state, val) {
      state.items.push(val);
    },
    setSources(state, val) {
      state.sources = val;
    },
    addSource(state, val) {
      state.sources.push(val);
    },
    removeSource(state, val) {
      state.sources = state.sources.filter((source) => source.uid !== val);
    },
  },
  actions: {
    async fetchSources({ commit, rootState }) {
      const query = collection(
        db,
        "workspaces",
        rootState.workspace.workspace.uid,
        "sources",
      );
      const querySnapshot = await getDocs(query);
      let sources = [];
      querySnapshot.docs.map((doc) => {
        sources.push(doc.data());
      });
      console.log("sources", sources);
      commit("setSources", sources);
      return;
    },
    async addSource({ commit, dispatch, rootState }, val) {
      const docRef = await addDoc(
        collection(
          db,
          "workspaces",
          rootState.workspace.workspace.uid,
          "sources",
        ),
        val,
      );
      await updateDoc(docRef, {
        uid: docRef.id,
      });
      commit("addSource", { ...val, uid: docRef.id });
      await new Promise((resolve) => setTimeout(resolve, 5000));
      dispatch("fetchKnowledgeItems");

      commit("setNotification", {
        show: true,
        text: "Source added successfully",
        type: "primary",
        icon: "mdi-plus",
      });
    },
    async deleteSource({ commit, rootState }, uid) {
      const docRef = doc(
        db,
        "workspaces",
        rootState.workspace.workspace.uid,
        "sources",
        uid,
      );
      await deleteDoc(docRef);
      commit("removeSource", uid);
      commit("setNotification", {
        show: true,
        text: "Source deleted successfully",
        type: "primary",
        icon: "mdi-delete",
      });
    },
    async addKnowledgeItem({ commit, dispatch, rootState }, val) {
      console.log("addKnowledgeItem", val);

      if (val.file) {
        const uploadedFile = await dispatch("uploadFile", val);
        val = uploadedFile;
      } else {
        const docRef = await addDoc(
          collection(
            db,
            "workspaces",
            rootState.workspace.workspace.uid,
            "knowledge",
          ),
          val,
        );
        await updateDoc(docRef, {
          uid: docRef.id,
        });
        val.uid = docRef.id;
      }

      commit("addKnowledgeItem", val);
      return;
    },
    async fetchKnowledgeItems({ commit, dispatch, rootState }) {
      commit("setLoading", { type: "knowledge", val: true });
      const knowledgeRef = collection(
        db,
        "workspaces",
        rootState.workspace.workspace.uid,
        "knowledge",
      );
      const knowledgeQuery = query(knowledgeRef, where("deleted", "!=", true));
      const querySnapshot = await getDocs(knowledgeQuery);
      let items = [];
      querySnapshot.docs.map((doc) => {
        items.push(doc.data());
        console.log("item", doc.data().title);
        console.log("item", doc.data().deleted);
      });
      // Ensure items are sorted by created_at (newest first)
      items.sort((a, b) => (b.created_at || 0) - (a.created_at || 0));

      dispatch("fetchSources");
      commit("setItems", items);
      commit("setLoading", { type: "knowledge", val: false });
    },
    async uploadFile({ rootState }, upload) {
      console.log(upload.file);
      console.log("upload", upload);
      function getType(ext) {
        const e = ext.toLowerCase();
        switch (e) {
          case "jpg":
          case "gif":
          case "bmp":
          case "png":
          case "jpeg":
          case "webp":
          case "svg":
            return "image";
        }

        switch (e) {
          case "m4v":
          case "avi":
          case "mpg":
          case "mp4":
          case "mov":
          case "webm":
          case "mkv":
            return "video";
        }

        switch (e) {
          case "mp3":
          case "wav":
          case "m4a":
          case "aac":
          case "ogg":
          case "flac":
            return "audio";
        }

        switch (e) {
          case "pdf":
          case "doc":
          case "docx":
          case "xls":
          case "xlsx":
          case "ppt":
          case "pptx":
          case "txt":
          case "rtf":
          case "odt":
          case "ods":
          case "odp":
            return "document";
        }
        return false;
      }

      var fileName = upload.file.name;
      var fileExtension = fileName.split(".").pop();
      const filesize = Math.floor(upload.file.size / 1024);
      const title = upload.title?.trim() || fileName;
      const type = getType(fileExtension);
      const storage = getStorage();

      const metadata = {
        contentType: upload.file.type,
      };
      const docRef = await addDoc(
        collection(
          db,
          "workspaces",
          rootState.workspace.workspace.uid,
          "knowledge",
        ),
        {
          title: title,
          extension: fileExtension,
          created_at: Math.floor(Date.now() / 1000),
          created_by: upload.created_by,
          created_by_email: upload.created_by_email,
          workspace: rootState.workspace.workspace.uid,
          size: filesize,
          posts: [],
          thumbnail: null,
          content_pillar: upload.content_pillar,
          class: "knowledge",
          type: type,
          status: "New",
          priority: "Medium",
          source: "Manual",
          deleted: false,
        },
      );
      await updateDoc(docRef, {
        uid: docRef.id,
      });
      const storageRef = ref(
        storage,
        `${rootState.workspace.workspace.uid}/knowledge/${docRef.id}.${fileExtension}`,
      );

      const uploadTask = uploadBytesResumable(
        storageRef,
        upload.file,
        metadata,
      );
      if (upload.onProgress && typeof upload.onProgress === "function") {
        uploadTask.on("state_changed", (snapshot) => {
          const percent =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          upload.onProgress(percent);
        });
      }
      await uploadTask;

      const downloadURL = await getDownloadURL(storageRef);
      const updateRef = doc(
        db,
        "workspaces",
        rootState.workspace.workspace.uid,
        "knowledge",
        docRef.id,
      );

      await updateDoc(updateRef, {
        uid: docRef.id,
        src: downloadURL,
      });
      return { ...upload, src: downloadURL, uid: docRef.id };
    },
    async deleteKnowledgeItem({ commit, rootState }, uid) {
      const docRef = doc(
        db,
        "workspaces",
        rootState.workspace.workspace.uid,
        "knowledge",
        uid,
      );
      await updateDoc(docRef, {
        deleted: true,
      });
      commit("removeKnowledgeItem", uid);
    },
    async convertToPosts({ commit, dispatch, rootState }, request) {
      const convertToPosts = httpsCallable(functions, "convertToPosts", {
        timeout: 300000,
      });
      console.log("rootState", rootState.workspace.brand);
      console.log("convertToPosts", request);
      commit("setConvertToPosts", "generating", { root: true });
      try {
        const result = await convertToPosts({
          source_content:
            request.items.filter((item) => item.url).map((item) => item.url) ||
            [],
          files: request.items.filter((item) => item.src),
          items: request.items,
          post_count: request.post_count,
          include_images: JSON.stringify(request.include_images),
          brand_voice: JSON.stringify(rootState.workspace.brand.voice),
          content_pillar: request.items[0].type,
          custom_instructions: request.custom_instructions,
          brand_primary: rootState.workspace.branding.color.primary || "",
          brand_accent: rootState.workspace.branding.color.accent || "",
          brand_background: rootState.workspace.branding.color.background || "",
          brand_button: rootState.workspace.branding.color.button || "",
          brand_text: rootState.workspace.branding.color.text || "",
          brand_logo_url: rootState.workspace.branding.logo.dark || "",
          category: request.category,
          use_file: request.mediaOption === "use_file" ? true : false,
        });
        console.log("result", result.data);
        await Promise.all(
          request.items.map(async (item) => {
            const knowledgeRef = doc(
              db,
              "workspaces",
              rootState.workspace.workspace.uid,
              "knowledge",
              item.uid,
            );
            await updateDoc(knowledgeRef, {
              status: "Converted",
            });
          }),
        );
        dispatch("fetchKnowledgeItems");
        dispatch("fetchPosts");
        commit("setConvertedItemUids", request.items.map((item) => item.uid), { root: true });
        commit("setConvertToPosts", "done", { root: true });
        commit("setNotification", {
          show: true,
          text: "Posts converted successfully",
          type: "success",
          icon: "mdi-check-circle",
          redirect: "/library",
        });
        return result.data;
      } catch (error) {
        let text = "Error converting to posts";
        if (error.message.includes("Not enough tokens")) {
          text = "Not enough tokens";
        } else if (error.message.includes("overloaded")) {
          text = "Server is overloaded. Please try again later.";
        } else {
          text = "Error converting to posts";
        }
        commit("setConvertToPosts", "idle", { root: true });
        commit("setNotification", {
          show: true,
          text: text,
          type: "error",
          icon: "mdi-alert-circle",
        });
        console.log("error", error);
        return null;
      }
    },
  },
  getters: {},
};

export default knowledge;
